import PagesRepository from './PagesRepository';
import ProductsRepository from './ProductsRepository';
import DailyNewsRepository from './DailyNewsRepository';
import SiteTemplatesRepository from './SiteTemplatesRepository';
import CommunityPostsRepository from './CommunityPostsRepository';
import CourseRepository from './CourseRepository';
import VideoRepository from './VideoRepository';
import NotificationsRepository from "./NotificationsRepository";
import NewsletterRepository from "./NewsletterRepository";
import BlogPostsRepository from "./BlogPostsRepository";
import ContactRepository from "./ContactRepository";
import CommonRepository from "./CommonRepository";

const repositories = {
    pages: PagesRepository,
    products: ProductsRepository,
    dailyNews: DailyNewsRepository,
    siteTemplates: SiteTemplatesRepository,
    communityPosts: CommunityPostsRepository,
    course: CourseRepository,
    video: VideoRepository,
    notifications: NotificationsRepository,
    newsletter: NewsletterRepository,
    blogPosts: BlogPostsRepository,
    common: CommonRepository,
    contact: ContactRepository
};

export const RepositoryFactory = {
    get: name => repositories[name]
};